import React, { ReactNode, useMemo } from 'react';

import { renderMarkdown } from './simple-markdown.tsx';
import './LegalDocument.scss';

interface LegalDocumentProps {
  content: string;
  footer?: ReactNode;
}

const LegalDocument: React.FC<LegalDocumentProps> = ({ content, footer }) => {
  const nodes = useMemo(() => renderMarkdown(content), [content]);

  return (
    <section className="legal-document">
      <main>{nodes}</main>
      {footer ? (
        <footer className="legal-document__footer">{footer}</footer>
      ) : null}
    </section>
  );
};

export default LegalDocument;
